import { useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'
import Address from '@/components/primitives/Address'
import DataPoint, { DataPoints } from '@/components/primitives/DataPoint'
import {
  getCustomerAddress1,
  getCustomerAddress2,
  getCustomerCity,
  getCustomerContactEmail,
  getCustomerContactName,
  getCustomerContactPhone,
  getCustomerOrgNumber,
  getCustomerVatNumber,
  getCustomerZip,
  getNumberOfEmployees,
} from '@/ducks/customerReducer'
import withCustomerLoaded from '@/hocs/withCustomerLoaded'
import { numberFormat } from '@/util/formatters/numbers'

import './customer-info.scss'

const CustomerInfo = () => {
  const orgNumber = useSelector(getCustomerOrgNumber)
  const vatNumber = useSelector(getCustomerVatNumber)
  const numberOfEmployees = useSelector(getNumberOfEmployees)

  const contactName = useSelector(getCustomerContactName)
  const contactPhone = useSelector(getCustomerContactPhone)
  const contactEmail = useSelector(getCustomerContactEmail)

  const address1 = useSelector(getCustomerAddress1)
  const address2 = useSelector(getCustomerAddress2)
  const zip = useSelector(getCustomerZip)
  const city = useSelector(getCustomerCity)

  return (
    <div className="customer_info">
      <h3>
        <Translation id="Customer Information" />
      </h3>

      <DataPoints>
        <DataPoint header={<Translation id="Organizational Number" />} value={orgNumber} />

        {vatNumber && vatNumber !== orgNumber && (
          <DataPoint header={<Translation id="VAT Number" />} value={vatNumber} />
        )}

        {(address1 || address2 || zip || city) && (
          <DataPoint
            header={<Translation id="Company address" />}
            // @ts-ignore
            value={<Address street1={address1} street2={address2} zip={zip} city={city} />}
          />
        )}

        {(contactName || contactPhone || contactEmail) && (
          <DataPoint
            header={<Translation id="Contact Person" />}
            value={
              <>
                {contactPhone && <div>{contactName}</div>}
                {contactEmail && <div>{contactEmail}</div>}
                {contactPhone && <div>{contactPhone}</div>}
              </>
            }
          />
        )}

        {Boolean(numberOfEmployees) && (
          <DataPoint
            header={<Translation id="Employees" />}
            value={numberFormat(numberOfEmployees)}
          />
        )}
      </DataPoints>
    </div>
  )
}

export default withCustomerLoaded(CustomerInfo)
